import type { Reviver } from "./createReviver"

type JSONPrimitive = string | number | boolean | null
const isJSONPrimitive = (value: unknown): value is JSONPrimitive => {
  switch (typeof value) {
    case "string":
    case "number":
    case "boolean":
      return true
    default:
      return value === null
  }
}

const traverseJsonInternal = (data: any, reviver: Reviver, keys: readonly (string | number)[]) => {
  const entries: (readonly [string | number, unknown])[] = Array.isArray(data)
    ? data.map((value, index) => [index, value] as const)
    : Object.entries(data)

  for (const [key, value] of entries) {
    if (isJSONPrimitive(value)) {
      data[key] = reviver(key.toString(), value, { keys: [...keys, key] })
    } else {
      traverseJsonInternal(value, reviver, [...keys, key])
    }
  }

  return data
}

export const traverseJson = (data: any, reviver: Reviver) => {
  return traverseJsonInternal(data, reviver, [])
}
